import Hero from "@/components/home/Hero";
import CoreInsight from "@/components/home/CoreInsight";
import DtcMarketShift from "@/components/home/DtcMarketShift";
import ProgramCategories from "@/components/home/ProgramCategories";
import VendorNetworkAdvantage from "@/components/home/VendorNetworkAdvantage";
import CurationLogic from "@/components/home/CurationLogic";
import PlatformOverview from "@/components/home/PlatformOverview";
import FinancialWorkflow from "@/components/home/FinancialWorkflow";
import SecurityCompliance from "@/components/home/SecurityCompliance";
import IdealClients from "@/components/home/IdealClients";
import RoiDashboard from "@/components/home/RoiDashboard";
import FinalCta from "@/components/home/FinalCta";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <CoreInsight />
      <DtcMarketShift />
      <ProgramCategories />
      <VendorNetworkAdvantage />
      <CurationLogic />
      <PlatformOverview />
      <FinancialWorkflow />
      <SecurityCompliance />
      <IdealClients />
      <RoiDashboard />
      <FinalCta />
    </div>
  );
}
